import { Descriptions, Form, Input, Space, UploadFile } from 'antd';
import { VFC } from 'react';
import { FORM_LAYOUT_CONFIG } from 'consts/common';
import { FormItem } from 'components/Form/FormItem';
import { useScrollTopOnMount } from 'hooks/useScrollTopOnMount';
import { useReplaceMeterStore } from 'routes/meter_replacement/useStore';
import { RegisterStates } from 'routes/meter_replacement/components/RegisterStates';
import { useReplaceMeterStepsStore } from 'routes/meter_replacement/useStepsStore';
import { useMeterContext } from 'contexts/Meter';
import { FormattedMessage, useIntl } from 'react-intl';
import { OldValuesStepForm } from './slice';
import { OLD_VALUES_FORM_ID } from './constants';
import { DateTime } from './components/DateTime';
import { OldValuesStepContent as messages } from './messages';

export const OldValuesStepContent: VFC = () => {
  const [form] = Form.useForm();
  const intl = useIntl();

  const { setNextStep } = useReplaceMeterStepsStore();
  const { enmonMeter, inventoryMeter } = useMeterContext();

  const { replacementDate, oldSerialNumber, oldRegisterStates, setOldValuesStepValues } = useReplaceMeterStore();
  const handleValuesChange = (changedValues: Partial<OldValuesStepForm>, allValues: OldValuesStepForm) => {
    if ('oldRegisterStates' in changedValues) {
      setOldValuesStepValues({ oldRegisterStates: allValues.oldRegisterStates });
    } else {
      setOldValuesStepValues(allValues);
    }
  };

  const handleSubmit = () => {
    setNextStep();
  };

  const handlePhotoSelect = (fieldName: number, fileList: UploadFile[]) => {
    const updatedRegisterStates = oldRegisterStates?.map((registerState, index) => {
      if (index === fieldName) {
        return { ...registerState, photos: fileList };
      }
      return registerState;
    });
    form.setFieldsValue({ oldRegisterStates: updatedRegisterStates });
    setOldValuesStepValues({ oldRegisterStates: updatedRegisterStates });
  };

  useScrollTopOnMount();

  return (
    <Space className="w-100" direction="vertical" size="large">
      <Descriptions
        bordered
        column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
        size="small"
        title={<FormattedMessage {...messages.title} />}
      >
        <Descriptions.Item label={<FormattedMessage {...messages.strapiId} />}>{inventoryMeter?.id}</Descriptions.Item>
        <Descriptions.Item label={<FormattedMessage {...messages.sn} />}>{enmonMeter?.serial}</Descriptions.Item>
      </Descriptions>
      <Form
        form={form}
        id={OLD_VALUES_FORM_ID}
        layout="horizontal"
        onFinish={handleSubmit}
        onValuesChange={handleValuesChange}
        {...FORM_LAYOUT_CONFIG}
      >
        <FormItem
          initialValue={replacementDate}
          label={<FormattedMessage {...messages.replacementDateAndTimeLabel} />}
          name={'replacementDate' satisfies keyof OldValuesStepForm}
          rules={[
            {
              required: true,
              message: intl.formatMessage(messages.replacementDateAndTimeRequired),
            },
          ]}
        >
          <DateTime />
        </FormItem>
        <FormItem
          initialValue={oldSerialNumber}
          label={<FormattedMessage {...messages.oldMeterSerialNumberLabel} />}
          name={'oldSerialNumber' satisfies keyof OldValuesStepForm}
        >
          <Input disabled />
        </FormItem>

        <RegisterStates
          fieldName={'oldRegisterStates' satisfies keyof OldValuesStepForm}
          registerStates={oldRegisterStates ?? []}
          selectedUnits={enmonMeter?.registers?.map(({ unit }) => unit)}
          onPhotoSelect={handlePhotoSelect}
        />
      </Form>
    </Space>
  );
};
